module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "py-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.paymentSavedRequest
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.deleteInvoiceRequest
    }
  }), _vm._v(" "), _c('invoices-toolbar', {
    attrs: {
      "page": _vm.page,
      "use-date-due": _vm.useDateDue,
      "with-search": _vm.activeMainComponent === "kanban",
      "title": _vm.title
    },
    on: {
      "reload": _vm.refresh,
      "setmain": _vm.setMainComponent,
      "setsecondary": _vm.setSecondaryComponent,
      "search": _vm.setSearch,
      "update:page": function($event) {
        _vm.page = $event
      },
      "update:useDateDue": function($event) {
        _vm.useDateDue = $event
      },
      "update:use-date-due": function($event) {
        _vm.useDateDue = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    class: _vm.mainComponentClasses
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "out-in": ""
    }
  }, [_c(_vm.mainComponent, {
    tag: "component",
    attrs: {
      "lazy-load": "",
      "loading": _vm.invoicesRequest.loading,
      "title": _vm.title,
      "headers": _vm.headers,
      "actions": _vm.invoiceActions,
      "appointments": _vm.appointmentsNeedingAttention,
      "transactions": _vm.transactions,
      "data": _vm.filteredInvoices,
      "search-string": _vm.searchString,
      "date-range": _vm.activeDateRange,
      "page": _vm.page
    },
    on: {
      "update:page": function($event) {
        _vm.page = $event
      },
      "edit": _vm.gotoInvoice,
      "view": _vm.openInNew,
      "send": _vm.gotoSend,
      "share": _vm.invoiceEvents.share,
      "delete": _vm.prepareToDelete,
      "addpayment": _vm.addPayment,
      "markaspaid": _vm.markAsPaid,
      "preview": _vm.setPreview,
      "primarycta": _vm.setPreview,
      "reload": _vm.refresh,
      "sendtomedicalaid": _vm.sendtomedicalaid,
      "showpaymentdialog": _vm.showPaymentDialog,
      "showcustomer": _vm.gotoCustomer
    }
  })], 1)], 1), _vm._v(" "), (_vm.activeSecondaryComponent) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "transition": "slide-x-reverse-transition"
    }
  }, [_c('v-btn', {
    attrs: {
      "right": "",
      "absolute": "",
      "fab": "",
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.activeSecondaryComponent = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c(_vm.secondaryComponent, {
    tag: "component",
    staticClass: "elevation-20",
    attrs: {
      "client": _vm.selectedClient,
      "invoice": _vm.invoice,
      "search-string": _vm.searchString,
      "appointments": _vm.activeAppointments,
      "with-close": false
    },
    on: {
      "close": function($event) {
        _vm.secondaryComponent = false
      },
      "edit": _vm.gotoInvoice,
      "send": _vm.gotoSend,
      "view": _vm.openInNew,
      "reload": _vm.refresh,
      "created": _vm.setPreview
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300px"
    },
    model: {
      value: (_vm.showConfirmDeleteDialog),
      callback: function($$v) {
        _vm.showConfirmDeleteDialog = $$v
      },
      expression: "showConfirmDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', [_vm._v("Please confirm")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to delete this invoice:\n        "), _c('p', [_vm._v(_vm._s(_vm.invoice.title) + " - " + _vm._s(_vm.invoice.date))])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showConfirmDeleteDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error",
    on: {
      "click": function($event) {
        return _vm.deleteInvoice(_vm.invoice)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49b7ffd0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Invoices.vue
// module id = 1414
// module chunks = 9